var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('sidebar'),_c('toolbar'),_c('v-content',[_c('v-progress-linear',{staticClass:"my-0",attrs:{"indeterminate":_vm.isLoading,"color":"primaryGradient","background-color":"accent","height":"3"}}),_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }